import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import React from 'react';

const WarningModal = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  body,
  yesButtonText,
  noButtonText,
  onCustomAction,
  customButtonText,
  children,
  loading,
  hardClose
}) => {
  const closeBtn = (
    <button className="close" onClick={hardClose} type="button">
      &times;
    </button>
  );

  return (
    <Modal
      isOpen={isOpen}
      zIndex={13000}
    >
      <ModalHeader close={!!!hardClose ? null : closeBtn}>
        <div style={{ color: 'red' }}>{title || 'Warning'}</div>
      </ModalHeader>

      <ModalBody>
        <div>{body || children}</div>
      </ModalBody>

      <ModalFooter
        className={
          customButtonText
            ? 'modalFooterEpiDelete extraButton'
            : 'modalFooterEpiDelete'
        }
      >
        {onCancel && (
          <Button
            outline
            color="secondary"
            onClick={onCancel}
            id="Warning-no"
          >
            {noButtonText || 'No'}
          </Button>
        )}

        {onConfirm && (
          <Button
            color="primary"
            onClick={onConfirm}
            disabled={loading}   // <<< was "disable"
            id="Warning-yes"
          >
            {yesButtonText || 'Yes'}
          </Button>
        )}

        {customButtonText && (
          <Button outline color="secondary" onClick={onCustomAction}>
            {customButtonText || 'No'}
          </Button>
        )}
      </ModalFooter>
    </Modal>
  );
};

export default WarningModal;
